import React from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { useAppStore } from '../store/appStore';
import { colors, typography, spacing } from '../theme';
import { useThemedStyles } from '../hooks/useThemedStyles';

export const LanguageToggle: React.FC = () => {
  const styles = useThemedStyles(getStyles);
  const uiLocale = useAppStore((state) => state.currentBusiness?.locale ?? state.uiLocale);
  const setUiLocale = useAppStore((state) => state.setUiLocale);
  const isArabic = uiLocale === 'ar';

  // Only show when there's no business locale forcing the language
  const businessLocale = useAppStore((state) => state.currentBusiness?.locale);
  if (businessLocale) return null;

  return (
    <TouchableOpacity
      style={styles.button}
      onPress={() => setUiLocale(isArabic ? 'en' : 'ar')}
      activeOpacity={0.7}
    >
      <Text style={styles.label}>{isArabic ? 'EN' : 'عربي'}</Text>
    </TouchableOpacity>
  );
};

const getStyles = () => StyleSheet.create({
  button: {
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.xs,
    borderRadius: spacing.borderRadius.md,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.background.surface,
  },
  label: {
    fontSize: typography.fontSize.sm,
    color: colors.primary,
    fontWeight: '600',
  },
});
